import { Button as ChakraButton, ButtonProps } from '@chakra-ui/react';
import { useChakraPriorityStyles } from 'src/hooks';

export const Button = (props: ButtonProps) => {
  const styles = useChakraPriorityStyles(props);

  return <ChakraButton {...props} {...styles} />;
};

Button.defaultProps = {
  textStyle: 'body-large-bold',
};
